import styled from "styled-components";
import { ConfirmDialog } from "primereact/confirmdialog";
import { theme } from "../../../styles/theme";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-bottom: 20px;

  ::-webkit-scrollbar {
    width: 8px !important;
  }

  ::-webkit-scrollbar-track {
    background-color: ${theme.colors.blue800} !important;
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray800} !important;
    border-radius: 0 !important;
  }
`;

export const CardWrapper = styled.div`
  margin: 15px;
  border-radius: 20px;
  display: flex;
  flex-direction: row;
  padding: 20px;
  align-items: center;
  justify-content: space-between;
  background-color: ${theme.colors.darkBlue};
  gap: 20px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  padding: 12px 16px;
  border-radius: 100px;
  border: 1px solid ${theme.colors.gray800};
  background: ${theme.colors.blue900};
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  font-size: 14px;
  outline: none;

  &::placeholder {
    color: ${theme.colors.gray800};
  }

  &:focus {
    border-color: ${theme.colors.primary};
  }
`;

export const LayoutTabs = styled.div`
  display: flex;
  gap: 8px;
`;

export const LayoutTab = styled.button<{ $active: boolean }>`
  padding: 10px 20px;
  border-radius: 100px;
  border: 1px solid ${(p) => (p.$active ? theme.colors.primary : theme.colors.gray800)};
  background: ${(p) => (p.$active ? theme.colors.primary : "transparent")};
  color: ${(p) => (p.$active ? theme.colors.white : theme.colors.gray800)};
  font-family: ${theme.font.poppins};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;

export const CreateButton = styled.button`
  padding: 10px 24px;
  border-radius: 100px;
  border: none;
  background: ${theme.colors.primary};
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    opacity: 0.8;
  }
`;

export const Badge = styled.span<{ $active: boolean }>`
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  background: ${(p) => (p.$active ? "rgba(76, 175, 80, 0.15)" : "rgba(244, 67, 54, 0.15)")};
  color: ${(p) => (p.$active ? "#4caf50" : "#f44336")};
`;

export const ActionsRow = styled.div`
  display: flex;
  gap: 8px;
`;

export const BackHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 15px 0;
`;

export const BackButton = styled.button`
  padding: 8px 16px;
  border-radius: 100px;
  border: 1px solid ${theme.colors.gray800};
  background: transparent;
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  font-size: 13px;
  cursor: pointer;

  &:hover {
    border-color: ${theme.colors.primary};
  }
`;

export const PageTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  margin: 0;
`;

export const ConfirmDialogStyled = styled(ConfirmDialog)`
  .p-dialog-header {
    background-color: ${theme.colors.darkBlue};
    color: ${theme.colors.white};
    font-family: ${theme.font.poppins};
  }

  .p-dialog-content {
    background-color: ${theme.colors.darkBlue};
    color: ${theme.colors.white};
    font-family: ${theme.font.poppins};
  }

  .p-dialog-footer {
    background: ${theme.colors.darkBlue};
    font-family: ${theme.font.poppins};
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
`;

export const InfoBox = styled.div`
  background: rgba(12, 116, 136, 0.1);
  border: 1px solid rgba(12, 116, 136, 0.3);
  border-radius: 12px;
  padding: 12px 16px;
  margin: 0 15px 0;
  font-size: 12px;
  color: ${theme.colors.lightBlue};
  font-family: ${theme.font.poppins};
  line-height: 1.6;
`;
